import { Booking, BookingModificationAction, BookingStatus, BookingUpdateModel } from "src/common/event/event.types";
import { Slot } from "src/containers/event/event.types";

export const mapBookingUpdate = (bookingToUpdate: Booking, slot: Slot, userId: string): BookingUpdateModel => {
  if (bookingToUpdate) {
    return {
      slotId: slot.id,
      bookingId: bookingToUpdate.id,
      action: BookingModificationAction.Update,
      booking: {
        id: bookingToUpdate.id,
        status: BookingStatus.Booked,
        bookedByContactId: userId,
        inviteeContactId: userId,
      },
    };
  } else {
    return {
      slotId: slot.id,
      action: BookingModificationAction.Create,
      booking: {
        status: BookingStatus.Booked,
        bookedByContactId: userId,
        inviteeContactId: userId,
      },
    };
  }
};
